<template>
  <label :class="['t-switch', { readonly }]">
    <input
      v-model="model"
      :disabled="readonly"
      :value="name"
      class="t-switch__input"
      type="checkbox"
    />
    <span class="t-switch__core"></span>
    <span v-if="$slots.default" class="t-switch__label"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'TSwitch',

  props: {
    value: { type: [Boolean, Array] },
    name: { type: String, default: null },
    readonly: Boolean
  },

  computed: {
    model: {
      set(val) {
        this.$emit('input', val)
      },

      get() {
        return this.value
      }
    }
  }
}
</script>
